<script setup lang="ts">
  import {
    SidebarMenu,
    SidebarMenuItem,
    SidebarMenuButton
  } from '@gat-ship/vue-components'
  import { useScrollToPermissionGroup } from '../composables/useScrollToPermissionGroup'

  // The access-role detail modal's section navigation, built with shadcn
  // Sidebar primitives (it lives inside the modal's SidebarProvider). Clicking a
  // section scrolls the permissions grid to that group; the group currently in
  // the scroll viewport is highlighted as active. Routed AccessRolePermissionsView
  // uses the SelectMenu-based AccessRoleSidebarScrollToMenu instead; both share
  // the scroll-spy logic via useScrollToPermissionGroup.
  const { visiblePermissionGroups, activeGroupNames, handleClick } =
    useScrollToPermissionGroup()

  // Overrides on top of sidebarMenuButtonVariants to match the user-settings
  // modal styling (auto height, muted inactive text). ring-inset: the sidebar
  // content scrolls, which would clip a ring drawn outside the button bounds.
  const menuButtonClass =
    'text-muted-foreground hover:bg-accent/50 hover:text-foreground data-[active=true]:hover:bg-accent data-[active=true]:hover:text-accent-foreground h-auto cursor-pointer px-3 py-2 focus-visible:ring-inset'
</script>

<template>
  <SidebarMenu>
    <SidebarMenuItem
      v-for="group in visiblePermissionGroups"
      :key="group.groupName"
    >
      <SidebarMenuButton
        :is-active="activeGroupNames.has(group.groupName)"
        :class="menuButtonClass"
        @click="handleClick(group.groupName)"
      >
        <component :is="group.icon" />
        <span>{{ group.groupName }}</span>
      </SidebarMenuButton>
    </SidebarMenuItem>
  </SidebarMenu>
</template>
